export type CameraState = "Enabled" | "Disabled";

export const CameraState = {
  Enabled: "Enabled",
  Disabled: "Disabled",
} as const;
